import { render } from "./OtherView.vue?vue&type=template&id=3fd8df75&scoped=true"
import script from "./OtherView.vue?vue&type=script&lang=js"
export * from "./OtherView.vue?vue&type=script&lang=js"

import "./OtherView.vue?vue&type=style&index=0&id=3fd8df75&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd8df75"]])

export default __exports__